import React from "react";

import {backgroundColor} from "@pg-design/helpers-css";

import {ContractorDescription} from "../components/ContractorDescription";
import {ContractorHeader} from "../components/ContractorHeader";
import {ContractorRegister} from "../components/ContractorRegister";

export const ContractorView = () => {
    return (
        <article css={backgroundColor("#fff")}>
            <ContractorHeader />
            <ContractorDescription />
            <ContractorRegister />
        </article>
    );
};
import React from "react";

import {backgroundColor} from "@pg-design/helpers-css";

import {ContractorDescription} from "../components/ContractorDescription";
import {ContractorHeader} from "../components/ContractorHeader";
import {ContractorRegister} from "../components/ContractorRegister";

export const ContractorView = () => {
    return (
        <article css={backgroundColor("#fff")}>
            <ContractorHeader />
            <ContractorDescription />
            <ContractorRegister />
        </article>
    );
};
